<template>
    <div align="left" justify="center" class="">
        <div align="center" justify="center" class="pa-3">
            <v-card align="left" justify="left">
                <v-card-text class="pa-3 font-weight-light white black--text">
                    <v-btn class="grey lighten-4" x-small fab icon
                        ><v-icon class="primary--text lighten-2 pa-2">
                            search
                        </v-icon></v-btn
                    >
                    Administração > Títulos em Revisão
                </v-card-text>
            </v-card>

            <v-card @keyup.native.enter="pesquisaAvancadaTitulos" class="my-2">
                <v-expansion-panels v-model="panel" class="px-3 pt-3 pb-0">
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <v-card-text
                                class="py-0 px-3 font-weight-light white black--text"
                            >
                                <v-btn class="grey lighten-4" x-small fab icon
                                    ><v-icon
                                        class="primary--text lighten-2 pa-2"
                                    >
                                        mdi-filter
                                    </v-icon></v-btn
                                >
                                Filtros
                            </v-card-text>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row align="center" class="ma-0 pa-0">
                                <v-col
                                    cols="12"
                                    xs="12"
                                    sm="12"
                                    md="4"
                                    lg="4"
                                    class="d-flex flex-row"
                                >
                                    <v-text-field
                                        solo
                                        small
                                        class="mt-5"
                                        label="Nosso número"
                                        hint="Informe o nosso número"
                                        placeholder="Ex.:477977"
                                        v-model="filtros.ds_nosso_numero"
                                        clearable
                                        data-cy="filtroNossoNumero"
                                        :loading="loading"
                                    ></v-text-field>
                                    <v-tooltip bottom>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                fab
                                                x-small
                                                class="ma-auto ml-2"
                                                elevation="0"
                                            >
                                                <v-icon
                                                    color="grey"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class=""
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Informe o Número do Título</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col
                                    cols="12"
                                    xs="12"
                                    sm="12"
                                    md="4"
                                    lg="4"
                                    class="d-flex flex-row"
                                >
                                    <v-text-field
                                        solo
                                        small
                                        class="mt-5"
                                        label="Nome"
                                        hint="Informe o nome para efetuar a busca"
                                        placeholder="Ex.: José"
                                        clearable
                                        v-model="filtros.nm_devedor"
                                        data-cy="nomeDevedor"
                                        :loading="loading"
                                    ></v-text-field>
                                    <v-tooltip bottom>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                fab
                                                x-small
                                                class="ma-auto ml-2"
                                                elevation="0"
                                            >
                                                <v-icon
                                                    color="grey"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>
                                            Informe o Nome que deseja encontrar,
                                            por exemplo: Ricardo
                                        </span>
                                    </v-tooltip>
                                </v-col>
                                <v-col
                                    cols="12"
                                    xs="12"
                                    sm="12"
                                    md="4"
                                    lg="4"
                                    class="d-flex flex-row"
                                >
                                    <v-select
                                        solo
                                        small
                                        class="mt-5"
                                        label="Tipo de revisão"
                                        hint="Selecione os tipos de revisão"
                                        v-model="tiposRevisaoSelecionados"
                                        :items="tiposRevisaoOptions"
                                        item-text="text"
                                        item-value="value"
                                        multiple
                                        chips
                                        clearable
                                        data-cy="tipoRevisao"
                                        :loading="loading"
                                    ></v-select>
                                    <v-tooltip bottom>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                fab
                                                x-small
                                                class="ma-auto ml-2"
                                                elevation="0"
                                            >
                                                <v-icon
                                                    color="grey"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>
                                            Selecione os tipos de revisão a
                                            serem filtrados
                                        </span>
                                    </v-tooltip>
                                </v-col>
                                <v-col
                                    cols="12"
                                    xs="12"
                                    sm="12"
                                    md="4"
                                    lg="4"
                                    class="d-flex flex-row"
                                >
                                    <v-autocomplete
                                        solo
                                        small
                                        label="Sigla Apresentante"
                                        class="mt-5"
                                        clearable
                                        v-model="filtros.cd_apresentante"
                                        :items="apresentantesOrderByCd"
                                        item-value="cd_apresentante"
                                        item-text="cd_apresentante"
                                        :loading="
                                            loading || loadingApresentantes
                                        "
                                    ></v-autocomplete>
                                    <v-tooltip bottom>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                fab
                                                x-small
                                                class="ma-auto ml-2"
                                                elevation="0"
                                            >
                                                <v-icon
                                                    color="grey"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>
                                            Informe o apresentante que deseja
                                            encontrar - filtro por sigla
                                        </span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <v-col xs="12" sm="12" md="12" lg="12" class="text-right">
                    <v-btn
                        class="mr-3"
                        :loading="loading"
                        @click="limparFiltros"
                    >
                        Limpar Filtros
                        <v-icon class="ml-2">mdi-filter-remove-outline</v-icon>
                    </v-btn>
                    <v-btn
                        class="ma-0"
                        color="primary"
                        :loading="loading"
                        @click="pesquisaAvancadaTitulos(true)"
                    >
                        Filtrar
                        <v-icon class="ml-2">search</v-icon>
                    </v-btn>
                </v-col>
            </v-card>

            <v-data-table
                :headers="headers"
                :items="titulos"
                calculate-widths
                :options.sync="options"
                :server-items-length="totalTitulos"
                :loading="loading"
                :footer-props="{
                    itemsPerPageOptions: [10, 50, 100, 500],
                    itemsPerPageText: 'Itens por página:'
                }"
                loading-text="Pesquisando títulos..."
                no-data-text="Nenhum resultado encontrado... Faça uma pesquisa"
                no-results-text="Nenhum título encontrado..."
                class="elevation-1 pa-3"
            >
                <template v-slot:[`item.id_titulo`]="{ item }">
                    <span
                        v-if="item.ds_revisao != '' && item.cd_status == 99999"
                        title="Este título precisa ser revisado. "
                        :style="{ color: 'red' }"
                    >
                        {{ item.id_titulo }}</span
                    >
                    <span v-else :style="{ color: 'black' }">{{
                        item.id_titulo
                    }}</span>
                </template>
                <template v-slot:[`item.ds_nosso_numero`]="{ item }">
                    <span
                        v-if="item.ds_revisao != '' && item.cd_status == 99999"
                        title="Este título precisa ser revisado. "
                        :style="{ color: 'red' }"
                        >{{ item.ds_nosso_numero }}</span
                    >
                    <span v-else :style="{ color: 'black' }"
                        >{{ item.ds_nosso_numero }}
                    </span>
                </template>
                <template v-slot:[`item.nu_identificacao_devedor`]="{ item }">
                    <span
                        v-if="item.ds_revisao != '' && item.cd_status == 99999"
                        title="Este título precisa ser revisado. "
                        :style="{ color: 'red' }"
                        >{{ formatDocumento(item) }}</span
                    >
                    <span v-else :style="{ color: 'black' }">{{
                        formatDocumento(item)
                    }}</span>
                </template>
                <template v-slot:[`item.nm_devedor`]="{ item }">
                    <span
                        v-if="item.ds_revisao != '' && item.cd_status == 99999"
                        title="Este título precisa ser revisado. "
                        :style="{ color: 'red' }"
                        >{{ item.nm_devedor }}</span
                    >
                    <span v-else :style="{ color: 'black' }">{{
                        item.nm_devedor
                    }}</span>
                </template>
                <template v-slot:[`item.cd_status`]="{ item }">
                    <span
                        v-if="item.ds_revisao != '' && item.cd_status == 99999"
                        title="Este título precisa ser revisado. "
                        :style="{ color: 'red' }"
                        >{{ getDescSituacao(item) }}</span
                    >
                    <span v-else :style="{ color: 'black' }">{{
                        getDescSituacao(item)
                    }}</span>
                </template>
                <template v-slot:[`item.cd_uf_devedor`]="{ item }">
                    <span
                        v-if="item.ds_revisao != '' && item.cd_status == 99999"
                        title="Este título precisa ser revisado. "
                        :style="{ color: 'red' }"
                        >{{ item.cd_uf_devedor }}</span
                    >
                    <span v-else :style="{ color: 'black' }">{{
                        item.cd_uf_devedor
                    }}</span>
                </template>
                <template v-slot:[`item.ds_revisao`]="{ item }">
                    <span
                        v-if="item.ds_revisao"
                        :style="{ color: 'red', fontWeight: 'bold' }"
                        >{{ item.ds_revisao }}</span
                    >
                    <span v-else>-</span>
                </template>
                <template v-slot:[`item.action`]="props">
                    <v-btn
                        elevation="1"
                        width="100%"
                        class="mr-2 grey white--text"
                        @click="abrirDetalhesTitulo(props.item)"
                        full-width
                        small
                        :style="{ color: 'primary' }"
                        :data-cy="`editarTitulo${props.index}`"
                    >
                        <v-icon class="mr-2" :style="{ color: 'white' }">
                            edit
                        </v-icon>
                        Corrigir
                    </v-btn>
                </template>
            </v-data-table>
        </div>

        <v-dialog
            v-model="showRevisaoModal"
            max-width="900px"
            persistent
            overlay-opacity="0.8"
        >
            <DetalheTituloRevisao
                v-if="showRevisaoModal && selectedTitulo"
                :titulo="selectedTitulo"
                @fecharModal="handleFecharModal"
            />
        </v-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import * as Formatter from '@/helpers/Formatter';
import ApresentanteService from '../services/apresentanteService';
import ComarcaService from '../services/ComarcaService';
import TituloService from '../services/TituloService';
import lodash from 'lodash';
import MotivoRevisaoService from '../services/MotivoRevisaoService';
import DetalheTituloRevisao from '../components/DetalheTituloRevisao.vue';

export default {
    name: 'TitulosEmRevisao',
    components: {
        DetalheTituloRevisao
    },
    data() {
        return {
            apresentanteService: new ApresentanteService(Vue.http, this.$store),
            comarcaService: new ComarcaService(Vue.http, this.$store),
            tituloService: new TituloService(Vue.http, this.$store),
            motivoRevisaoService: new MotivoRevisaoService(
                Vue.http,
                this.$store
            ),
            panel: 0,
            dataApontamentoInicial: false,
            dataApontamentoFinal: false,
            motivosRevisao: [],
            apresentantes: [],
            apresentantesOrderByCd: [],
            filtros: {
                busca_exata: false,
                ds_revisao: '[ND][ED],[ED][ND],[ED],[ND]'
            },
            loading: false,
            loadingApresentantes: false,
            loadingComarcas: false,
            headers: [
                {
                    text: 'ID',
                    sortable: true,
                    value: 'id_titulo'
                },
                {
                    text: 'Nosso Número',
                    sortable: true,
                    value: 'ds_nosso_numero'
                },
                {
                    text: 'CPF/CNPJ',
                    sortable: true,
                    value: 'nu_identificacao_devedor'
                },
                {
                    text: 'Nome',
                    sortable: true,
                    value: 'nm_devedor'
                },
                {
                    text: 'Apresentante',
                    sortable: true,
                    value: 'cd_apresentante'
                },
                {
                    text: 'Protocolo',
                    sortable: false,
                    value: 'apontamento_nu_protocolo'
                },
                {
                    text: 'Envio',
                    sortable: false,
                    value: 'st_envio'
                },
                {
                    text: 'Status',
                    sortable: false,
                    value: 'cd_status'
                },
                {
                    text: 'UF',
                    sortable: false,
                    value: 'cd_uf_devedor'
                },
                {
                    text: 'Revisão',
                    sortable: false,
                    value: 'ds_revisao'
                },
                {
                    text: 'Nº Devedores',
                    sortable: false,
                    value: 'nu_quantidade_devedores'
                },
                { text: ' ', sortable: false, value: 'action', width: '15%' }
            ],
            titulos: [],
            options: {
                page: 1,
                itemsPerPage: 10
            },
            totalTitulos: 0,
            situacoesTitulo: this.$store.getters.situacoesTitulo || [],
            tiposRevisao: ['[ED]', '[ND]'],
            tiposRevisaoOptions: [
                { value: '[ED]', text: '[ED] Endereço Devedor' },
                { value: '[ND]', text: '[ND] Nome devedor' }
            ],
            tiposRevisaoSelecionados: [],
            showRevisaoModal: false,
            selectedTitulo: null,
            initialLoad: true
        };
    },
    async mounted() {
        this.situacoesTitulo = this.$store.getters.situacoesTitulo || [];
        await this.listarApresentantes();
        // this.pesquisaAvancadaTitulos();
    },
    computed: {
        computedMinDate() {
            return this.filtros.data_apontamento_inicial
                ? this.filtros.data_apontamento_inicial
                : null;
        },
        computedMaxDate() {
            return this.filtros.data_apontamento_final
                ? this.filtros.data_apontamento_final
                : null;
        },
        formattedRevisaoFilter() {
            if (
                !this.tiposRevisaoSelecionados ||
                this.tiposRevisaoSelecionados.length === 0 ||
                this.tiposRevisaoSelecionados.length ===
                    this.tiposRevisaoOptions.length
            ) {
                return '[ND][ED],[ED][ND],[ED],[ND]';
            }
            if (this.tiposRevisaoSelecionados.length === 1) {
                return this.tiposRevisaoSelecionados[0];
            }
            return '[ND][ED],[ED][ND],[ED],[ND]';
        }
    },
    watch: {
        options: {
            handler() {
                if (this.initialLoad) {
                    this.initialLoad = false;
                    return;
                }

                this.pesquisaAvancadaTitulos();
            },
            deep: true
        },
        tiposRevisaoSelecionados: {
            handler() {
                this.filtros.ds_revisao = this.formattedRevisaoFilter;
            },
            deep: true
        }
    },
    methods: {
        validarSelecaoData(val, booleano) {
            if (val && val.length === 2) {
                this[booleano] = false;
            }
        },
        limparData(tipoData) {
            if (tipoData === 'apontamentoInicial') {
                delete this.filtros.data_apontamento_inicial;
            }
            if (tipoData === 'apontamentoFinal') {
                delete this.filtros.data_apontamento_inicial;
            }
        },
        limparFiltros() {
            this.filtros = {
                busca_exata: false,
                ds_revisao: '[ND][ED],[ED][ND],[ED],[ND]'
            };
            this.tiposRevisaoSelecionados = [];
        },
        abrirDetalhesTitulo(titulo) {
            this.selectedTitulo = titulo;
            this.showRevisaoModal = true;
        },

        handleFecharModal(updated = false) {
            this.showRevisaoModal = false;

            if (updated) {
                this.pesquisaAvancadaTitulos();
                this.listarApresentantes();
            }
        },
        async listarApresentantes() {
            this.loadingApresentantes = true;
            try {
                const response = await this.apresentanteService.listarApresentantes(
                    null,
                    true
                );
                if (response.status == 200) {
                    let arr_apresentantes = [...response.body];
                    this.apresentantesOrderByCd = response.body;

                    arr_apresentantes.sort((a, b) => {
                        let nomeA = a.nm_apresentante.toUpperCase();
                        let nomeB = b.nm_apresentante.toUpperCase();
                        if (nomeA < nomeB) {
                            return -1;
                        }
                        if (nomeA > nomeB) {
                            return 1;
                        }
                        return 0;
                    });

                    this.apresentantes = arr_apresentantes;
                }
            } catch (e) {
                // erro silencioso
            } finally {
                this.loadingApresentantes = false;
            }
        },
        async pesquisaAvancadaTitulos(search = false) {
            try {
                if (search) {
                    this.options.page = 1;
                }
                this.loading = true;
                let filtro = lodash.cloneDeep(this.filtros);

                if (filtro.nu_identificacao_devedor) {
                    filtro.nu_identificacao_devedor =
                        this.filtros.nu_identificacao_devedor
                            .toUpperCase()
                            .replace(/[^A-Z0-9]/g, '');
                }

                filtro.ds_revisao = this.formattedRevisaoFilter;

                if (
                    !this.situacoesTitulo ||
                    this.situacoesTitulo.length === 0
                ) {
                    this.situacoesTitulo =
                        this.$store.getters.situacoesTitulo || [];
                }

                if (this.options.sortBy && this.options.sortBy.length > 0) {
                    filtro.orderBy = this.options.sortBy[0];
                    filtro.orderDir = this.options.sortDesc[0] ? 'desc' : 'asc';
                }

                const response = await this.tituloService.pesquisaAvancadaTitulos(
                    filtro,
                    this.options.page,
                    this.options.itemsPerPage
                );

                this.titulos = response.titulos || [];
                this.totalTitulos = response.total_titulos || 0;
            } catch (error) {
                console.error('Error in search:', error);
                this.titulos = [];
                this.totalTitulos = 0;
            } finally {
                this.loading = false;
            }
        },
        formatDocumento(titulo) {
            return Formatter.formatDocumento(
                titulo.nu_identificacao_devedor,
                titulo.tp_identificacao_devedor
            );
        },
        getDescSituacao(item) {
            if (!this.situacoesTitulo || this.situacoesTitulo.length === 0) {
                this.situacoesTitulo =
                    this.$store.getters.situacoesTitulo || [];
            }
            const situacao = this.situacoesTitulo.find(
                s => s.cd_status == item.cd_status
            );
            return situacao ? situacao.nm_status : '-';
        }
    }
};
</script>

<style lang="scss">
.v-dialog {
    z-index: 2000 !important;
    position: relative;
}
</style>
